import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { headerLinkListStyles } from "@insite/content-library/Widgets/Header/HeaderLinkList";

import { css } from "styled-components";

headerLinkListStyles.link = mergeToNew(headerLinkListStyles.link, {
    width: 12,
    css: css`
        position: relative;
        & p {
            font-size: 0.8rem;
            font-family: "FrutigerCn";
        }
    `,
});

headerLinkListStyles.headerLinkListWrapper = mergeToNew(headerLinkListStyles.headerLinkListWrapper, {
    width: 12,
    css: css`
        padding: 0 0 10px 0;
    `,
});
